<div class="sync-progress-container" *ngIf="isVisible$ | async">
  <div class="progress-header">
    <div class="progress-info">
      <mat-icon
        [svgIcon]="getStatusIcon()"
        [class]="getStatusColorClass()"
        class="icon-size-5 me-2"
      ></mat-icon>
      <span class="progress-title">
        {{ 'Sync Progress' | transloco }}
      </span>
    </div>
  </div>

  <div class="progress-content">
    <!-- Show completion indicator when sync is completed -->
    <div *ngIf="isSyncCompleted()" class="completion-indicator" [class.failed]="isSyncFailed()">
      <div class="completion-content">
        <mat-icon
          [svgIcon]="isSyncFailed() ? 'heroicons_solid:x-circle' : 'heroicons_solid:check-circle'"
          [ngClass]="isSyncFailed() ? 'text-error' : 'text-success'"
          class="icon-size-6 me-2"
        ></mat-icon>
        <span class="completion-text">
          {{ (isSyncFailed() ? 'integration.sync_failed' : 'Sync Completed') | transloco }}
        </span>
      </div>

      <button
        type="button"
        class="close-button"
        (click)="onClose()"
        [attr.aria-label]="'Close' | transloco"
      >
        <mat-icon svgIcon="close" class="icon-size-4"></mat-icon>
      </button>
    </div>

    <!-- Show progress bar when sync is in progress -->
    <div *ngIf="!isSyncCompleted()" class="progress-bar-container">
      <div class="progress-bar">
        <div
          class="progress-fill"
          [style.width.%]="progressState?.percentage || 0"
          [class]="getProgressBarClass()"
        ></div>
      </div>
    </div>

    <div class="progress-details">
      <div class="progress-message">
        {{ getProgressMessage() }}
      </div>

      <div class="progress-percentage" *ngIf="!isSyncCompleted()">
        {{ progressState?.percentage || 0 | number: '1.0-1' }}%
      </div>
    </div>
  </div>
</div>
